import WarningDialog from './WarningDialog.vue';

export default {
  install(Vue) {
    Vue.component('WarningDialog', WarningDialog);
    Vue.mixin({
      methods: {
        showWarning(msg, title = '') {
          this.$root.$emit('show-warning', { title, msg });
          return new Promise((resolve) => {
            this.$root.$on('hide-warning', () => {
              resolve();
              this.$root.$off('hide-warning');
            });
          });
        },
      },
    });
  },
};
